export default "__VITE_ASSET__26b68809__"